import { all } from "redux-saga/effects";
import { userSagas } from "store/sagas/user";
import { authSagas } from "store/sagas/auth";
import { courseSagas } from "store/sagas/course";

export default function* rootSaga() {
  yield all([...authSagas, ...userSagas, ...courseSagas]);
}
